import { LocalStorage } from '@injectivelabs/utils'
import { tokenStaticFactory } from '@shared/service'
import { env, NETWORK } from '@shared/utils/constant'
import { tokens } from '@/app/json'
import type { TokenStatic } from '@injectivelabs/sdk-ts'

tokenStaticFactory.mapRegistry(tokens as TokenStatic[])

// Singletons
export const localStorage: LocalStorage = new LocalStorage(
  `inj-hub-network-v5-${NETWORK}-${env.VITE_ENV || 'mainnet'}`
)
